var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.keycloak && _vm.keycloak.authenticated)?_c('Admin',{attrs:{"keycloak":_vm.keycloak}}):_c('Guest')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }